import ImageMapSectionWithListOverlay from './ImageMapSectionWithListOverlay';

export default ImageMapSectionWithListOverlay;